import React, { useState } from "react";
import { useNavigate } from "react-router";
import Container from "../../components/Container";
import WorkContentCreateTable from "../../components/work-contents/WorkContentCreateTable";
import WorkHeader from "../../components/work-contents/WorkHeader";
import Dialog from "../../components/Dialog";
import CancelButton from "../../components/forms/buttons/CancelButton";
import GreenButton from "../../components/forms/buttons/GreenButton";
import { dateService } from "../../services/DateService";
import { workContentService } from "../../services/WorkContentService";
import { useSnackbarContext } from "../../components/snackbar/SnackbarContext";

/**
 * 新規作業内容登録ページ（手動入力）
 * @class WorkContentsCreatePage
 */
export default function WorkContentsCreatePage() {
  const [workContents, setWorkContents] = useState({ workType: 1 });
  const [errors, setErrors] = useState({});
  const [isDialogOpen, setDialogOpen] = useState(false);
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbarContext();

  /**
   * 変更された入力欄の値を作業内容に反映する
   * @param {string} name 項目名
   * @param {string} value 値
   * @memberof WorkContentsCreatePage
   */
  const onChange = (name, value) => {
    setWorkContents({ ...workContents, [name]: value });
  };
  /**
   * 作業開始日時を保存する
   * @memberof WorkContentsCreatePage
   */
  const onStart = async () => {
    try {
      setDialogOpen(false);
      onChange("startedAt", dateService.formatCurrentDatetime());
      const params = {
        ...workContents,
        startedAt: dateService.formatCurrentDatetime(),
      };
      const result = (await workContentService.createDirect(params)).data;
      if (result.success) {
        navigate(`/work-contents/edit/${result.body?.workId ?? 1}`, {
          replace: true,
        });
      } else {
        showSnackbar("error", result.message);
      }
    } catch (error) {
      console.error(error);
    }
  };
  /**
   * 入力データをチェックする
   * @memberof WorkContentsCreatePage
   */
  const checkParams = () => {
    const errors = workContentService.checkRequired(workContents);
    setErrors(errors);
    setDialogOpen(Object.keys(errors).length === 0);
  };

  return (
    <Container title="手動入力">
      <div id="work-contents-create-page">
        <WorkHeader title="手動入力" subTitle="MANUAL INPUT" />
        <WorkContentCreateTable
          title="直接作業の手動入力"
          subtitle="各項目を選択・入力して、作業を開始します"
          workContents={workContents}
          onChange={onChange}
          onReset={() => setWorkContents({ workType: 1 })}
          onStart={checkParams}
          errors={errors}
        />
      </div>
      <Dialog
        open={isDialogOpen}
        onClose={() => setDialogOpen(false)}
        title="確認"
        actions={
          <>
            <CancelButton onClick={() => setDialogOpen(false)} />
            <GreenButton title="開始する" onClick={onStart} />
          </>
        }
      >
        入力内容で直接作業を開始します。よろしいですか？
      </Dialog>
    </Container>
  );
}
